import { Icon, Stack, Tooltip } from '@sixfold/common-ui';
import { isNil } from '@sixfold/typed-primitives';
import React from 'react';

import { FormattedDate } from '../../../components/date_formatting/formatted_date';

interface StatusRevertedTooltipProps {
  statusLabel: string;
  transitionedAt?: string | Date | null;
}

export const StatusRevertedTooltip: React.FC<StatusRevertedTooltipProps> = ({ statusLabel, transitionedAt }) => {
  const tooltipContent = isNil(transitionedAt) ? (
    <>{`Status reverted to '${statusLabel}'`}</>
  ) : (
    <>
      {`Status reverted to '${statusLabel}' as of `}
      <FormattedDate date={transitionedAt} showTime={false} showTimezone={false} />
    </>
  );

  return (
    <Tooltip content={tooltipContent} placement="top">
      <Stack>
        <Icon name="small-triangular-alert" kind="warning" />
      </Stack>
    </Tooltip>
  );
};
